import DeFlag from './DeFlag';
import EnFlag from './EnFlag';
import React from 'react';

const flags: Record<string, React.ReactNode> = {
  en: <EnFlag />,
  de: <DeFlag />,
};

const FlagIcon = ({ language }: { language: string }) => {
  return flags[language] || <EnFlag />;
};

export default FlagIcon;
